import http from './http';
import {ChatRequest, ChatResponse} from '../types';

export async function sendChat(payload: ChatRequest): Promise<ChatResponse> {
    const res = await http.post<ChatResponse>('/chat', payload);
    return res.data;
}

export async function resetChat(): Promise<void> {
    await http.delete('/chat/reset');
}
